module.exports = __webpack_public_path__ + "img/disetujui_dibayarkan_penuh.55eb69be.svg";